<template>
  <div>
    <div class="header">
      <img src="/static/header-tongji.png">
    </div>
    <div class="content">
      <div class="item-block">
        <div class="item-detail" style="margin: 0px;">
          <div class="item-header" style="font-size: 16px;">整个平台关注未绑定</div>
          <div class="item-count">{{unBindCount}}</div>
        </div>
      </div>
    </div>
    <div class="other-info" @click="showWorksitePicker">
      <div class="front time">
        <span class="iconfont icon-map"></span>
        <span class="title">网点</span>
      </div>
      <div class="end time">
        <span v-if="selectedWorksite.value">{{selectedWorksite.text}}</span>
        <span v-else>全部</span>
        <span class="iconfont icon-xiangyoujiantou"></span>
      </div>
    </div>
    <div class="other-info" @click="showDateSegmentPicker">
      <div class="front time">
        <span class="iconfont icon-rili"></span>
        <span class="title">时段</span>
      </div>
      <div class="end time">
        <span v-if="timeBegin && timeEnd">{{timeBegin}} ~ {{timeEnd}}</span>
        <span v-else>请选择</span>
        <span class="iconfont icon-xiangyoujiantou"></span>
      </div>
    </div>
    <div class="content border" v-for="item in data" :key="item.id">
      <div class="worksite-name">{{item.name}}（总绑{{item.bindCount}}人）</div>
      <div class="item-block">
        <div class="item-detail">
          <div class="item-header">新增綁定</div>
          <div class="item-count">{{item.newBindCount}}</div>
        </div>
        <div class="item-detail">
          <div class="item-header">取消关注</div>
          <div class="item-count">{{item.unSubscribeCount}}</div>
        </div>
        <div class="item-detail">
          <div class="item-header">外卖订单</div>
          <div class="item-count">{{item.liveOrderCount}}</div>
        </div>
      </div>
      <div class="item-block">
        <div class="item-detail">
          <div class="item-header">入库数量</div>
          <div class="item-count">{{item.expessCount}}</div>
        </div>
        <div class="item-detail">
          <div class="item-header">短信发送</div>
          <div class="item-count">{{item.smsCount}}</div>
        </div>
        <div class="item-detail">
          <div class="item-header">跑腿订单</div>
          <div class="item-count">{{item.paotuiCount}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      unBindCount: 0,
      worksites: [
        {
          text: "全部",
          value: "-1"
        }
      ],
      selectedWorksite: { text: "全部", value: "-1" },
      worksitePicker: null,
      timeBegin: "",
      timeEnd: "",
      paramTimeBegin: "",
      paramTimeEnd: "",
      dateSegmentPicker: null,
      dateSegmentData: [],
      data: []
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    // 半年选择跨度
    let min = {
      is: "cube-date-picker",
      title: "开始时间",
      min: moment()
        .subtract(6, "M")
        .toDate(),
      max: moment().toDate()
    };
    let max = {
      is: "cube-date-picker",
      title: "结束时间",
      min: moment()
        .subtract(6, "M")
        .toDate(),
      max: moment().toDate()
    };
    this.dateSegmentData = [min, max];

    axios
      .get("/api/worksite/listForTongji")
      .then(res => {
        if (res.data.success) {
          let result = res.data.data;
          for (let i = 0; i < result.length; i++) {
            this.worksites.push({
              text: result[i].shortName + "（" + result[i].schoolCampus + "）",
              value: result[i]._id
            });
          }
        }
      })
      .catch(err => {
        console.log(err);
      });

    axios
      .get("/api/user/unbindCount")
      .then(res => {
        if (res.data.success) {
          this.unBindCount = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    showWorksitePicker() {
      if (!this.worksitePicker) {
        this.worksitePicker = this.$createPicker({
          title: "网点选择",
          data: [this.worksites],
          onSelect: this.selectHandle
        });
      }
      this.worksitePicker.show();
    },
    showDateSegmentPicker() {
      this.dateSegmentPicker.show();
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.selectedWorksite = this.worksites[selectedIndex[0]];
      if (this.paramTimeBegin && this.paramTimeEnd) {
        this.query();
      }
    },
    query() {
      let params = {
        timeBegin: this.paramTimeBegin,
        timeEnd: this.paramTimeEnd
      };
      let loading = weui.loading("数据加载中", {
        className: "custom-classname"
      });
      axios
        .get("/api/worksite/tongji/" + this.selectedWorksite.value, {
          params: params
        })
        .then(res => {
          loading.hide(function() {});
          if (res.data.success) {
            this.data = res.data.data;
          }
        })
        .catch(err => {
          loading.hide(function() {});
          console.log(err);
        });
    }
  },
  mounted() {
    this.dateSegmentPicker = this.$createSegmentPicker({
      data: this.dateSegmentData,
      onSelect: (selectedDates, selectedVals, selectedTexts) => {
        this.timeBegin = moment(selectedDates[0]).format("YYYY.MM.DD");
        this.timeEnd = moment(selectedDates[1]).format("YYYY.MM.DD");
        this.paramTimeBegin = moment(selectedDates[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.paramTimeEnd = moment(selectedDates[1])
          .add(1, "day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.query();
      },
      onNext: (i, selectedDate, selectedValue, selectedText) => {
        this.dateSegmentData[1].min = selectedDate;
        if (i === 0) {
          this.dateSegmentPicker.$updateProps({
            data: this.dateSegmentData
          });
        }
      }
    });
  }
};
</script>

<style scoped>
.header img {
  width: 100%;
}

.other-info {
  border-bottom: 1px solid #eee;
  padding-top: 0.8rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 0.8rem;
  display: flex;
  color: black;
}

.front {
  flex: 2;
}

.end {
  flex: 1;
  text-align: right;
}

.money {
  color: #feb70f;
  font-weight: bold;
}

.time {
  flex: auto;
}

.iconfont {
  font-size: 1.1rem;
}

.title {
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  font-size: 1rem;
}

.content {
  text-align: center;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.border {
  padding-bottom: 10px;
  border: 1px solid #ff3a44;
}

.border:last-child {
  margin-bottom: 15px;
}

.worksite-name {
  background-color: #ff3a44;
  color: #ffffff;
  padding: 10px;
  font-size: 16px;
}
.item-block {
  display: flex;
  margin-top: 10px;
}

.item-detail {
  flex: 1;
  margin-left: 10px;
  margin-right: 10px;
  color: #ffffff;
  background-color: #ff3a44;
  position: relative;
}

.item-detail + .item-detail {
  margin-left: 0px;
}

.item-header {
  padding: 10px;
}

.item-count {
  background-color: #ffffff;
  margin: 1px;
  color: #000000;
  padding: 10px;
  font-size: 2rem;
  font-weight: bold;
}
</style>





// WEBPACK FOOTER //
// src/components/common/Tongji.vue